export default __webpack_public_path__ + "static/single-step-bebf68e5414fa4f45c6651815d154919.png";